import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import API from 'api/index.js';

const initialState = {
    vop: null,
    car: null,
    isConfirmed: false,
    isCompanyOwned: false,
    ssn: null,
    location: null,
    sites: [],
};

export const personRecycleSlice = createSlice({
    name: 'personRecycle',
    initialState,
    reducers: {
        reset: state => {
            state.car = initialState.car;
            state.isConfirmed = initialState.isConfirmed;
            state.isCompanyOwned = initialState.isCompanyOwned;
            state.location = initialState.location;
            state.sites = initialState.sites;
            state.ssn = initialState.ssn;
        },
        resetVop: state => { state.vop = initialState.vop; },
        setCar: (state, { payload }) => { state.car = payload; },
        setCarLocation: (state, { payload }) => { state.location = payload; },
        setIsCompanyOwned: (state, { payload }) => { state.isCompanyOwned = payload; },
        setIsConfirmed: (state, { payload }) => { state.isConfirmed = payload; },
        setSSN: (state, { payload }) => { state.ssn = payload; },
        setVOP: (state, { payload }) => { state.vop = payload; },
    },
    extraReducers: builder => {
        const { ownerShopSearch, ownerShopSingle, ownerCarSearch, ownerCarSearchBusiness } = API.endpoints;

        builder
            .addMatcher(ownerShopSearch.matchFulfilled, (state, { payload }) => {
                state.sites = [
                    ...payload.nearest_shop_per_operator.map(shop => ({ ...shop, isNearest: true })),
                    ...payload.remaining_shops,
                ];
            })
            .addMatcher(ownerShopSingle.matchFulfilled, (state, { payload }) => {
                const { id } = payload;
                const i = state.sites.findIndex(site => site.id === id);

                if(i !== -1) state.sites[i] = payload;
                else state.sites.push(payload);
            })
            .addMatcher(
                isAnyOf(
                    ownerCarSearch.matchFulfilled,
                    ownerCarSearchBusiness.matchFulfilled,
                ),
                (state, { payload, meta }) => {
                    const { plate_or_vin } = meta.arg.originalArgs;
                    state.car = payload;
                    state.vop = plate_or_vin;
                },
            )
            .addMatcher(
                isAnyOf(
                    ownerCarSearch.matchRejected,
                    ownerCarSearchBusiness.matchRejected,
                ),
                (state, { meta }) => {
                    const { plate_or_vin } = meta.arg.originalArgs;
                    state.car = null;
                    state.vop = plate_or_vin;
                },
            );
    },
});

export const {
    reset,
    setCar,
    resetVop,
    setCarLocation,
    setIsCompanyOwned,
    setIsConfirmed,
    setSSN,
    setVOP,
} = personRecycleSlice.actions;

export default personRecycleSlice.reducer;
